import { Component, EventEmitter, Input, Output, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { LorenImageConstants } from "../../../../shared/services/loren-image-service/constants/loren-image.constants";
import { LorenFileUploadComponent } from "../../../../shared/modules/loren-file-upload/components/loren-file-upload/loren-file-upload.component";
import { LorenImageCropperData } from "../../../../shared/modules/loren-image-cropper-dialog/interfaces/loren-image-cropper-data.interface";
import { LorenImageCropperDialogComponent } from "../../../../shared/modules/loren-image-cropper-dialog/components/loren-image-cropper-dialog/loren-image-cropper-dialog.component";
import { LorenSnackBarService } from "../../../../shared/services/loren-snack-bar-service/loren-snack-bar.service";
import { MatCardModule } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { LorenFileUploadModule } from "../../../../shared/modules/loren-file-upload/loren-file-upload.module";

@Component({
  imports: [MatCardModule, MatIcon, LorenFileUploadModule],
  selector: "loren-asset-image-uploader",
  standalone: true,
  styleUrls: ["./loren-asset-image-uploader.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-asset-image-uploader.component.html",
})
export class LorenAssetImageUploaderComponent {
  protected lorenSnackBarService = inject(LorenSnackBarService);
  private dialog = inject(MatDialog);

  public allowedFileTypes = ".png, .jpg, .jpeg";
  @Input() fileSizeLimitInMb = 4;
  @Input() entityImage = LorenImageConstants.defaultImage;
  @Input() look: string;
  @Input() uncropped = false;

  @ViewChild(LorenFileUploadComponent)
  fileUploadComponent: LorenFileUploadComponent;
  @Output() imageSelected = new EventEmitter<string>();

  showFileSizeExceededError() {
    this.lorenSnackBarService.showFileSizeExceededError(this.fileSizeLimitInMb);
  }

  showFileTypeNotAllowedError($event: string) {
    this.lorenSnackBarService.showFileTypeNotAllowedError(
      $event,
      this.allowedFileTypes
    );
  }

  handleNewImageUpload(newImage: string) {
    const dialogData: LorenImageCropperData = {
      sourceImage: newImage,
    };

    if (this.uncropped) {
      this.entityImage = newImage;
      this.imageSelected.emit(this.entityImage);
    } else {
      this.prepareDialog(dialogData).subscribe((result) => {
        if (!result) {
          return;
        }
        this.entityImage = dialogData.croppedImage;
        this.imageSelected.emit(this.entityImage);
      });
    }
  }

  triggerFileSelection() {
    this.fileUploadComponent.triggerFileInputClick();
  }

  private prepareDialog(dialogData: LorenImageCropperData) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = dialogData;
    dialogConfig.maxWidth = "600px";
    dialogConfig.maxHeight = "600px";

    const dialogRef = this.dialog.open(
      LorenImageCropperDialogComponent,
      dialogConfig
    );

    return dialogRef.afterClosed();
  }
}
